import axios from '@/plugin/axios';
import Routes from './routes';

export const getOrganizations = () => {
  return axios.get(Routes.organization, {
    params: {
      page: 1,
      limit: 1000,
    },
  });
};

export const getAllOrganizations = () => {
  return axios.get(Routes.organization, {
    params: {
      page: 1,
      limit: 1000,
    },
  });
};

export const getSavedDraft = async () => {
  try {
    const response = await axios.get(Routes.getDraft);
    return response;
  } catch (error) {
    console.log(error);
    return null;

    // console.error('Error fetching saved drafts:', error);
    // throw error;
  }
};

export const getOrganization = async (id) => {
  try {
    const response = await axios.get(`${Routes.organization}${id}`);
    console.log(response, 'response');

    return response;
  } catch (error) {
    console.error('Error fetching organization:', error);
    throw error;
  }
};
export const approveOrganization = async (id) => {
  try {
    const response = await axios.post(`${Routes.organization}${id}/approve/`);
    return response;
  } catch (error) {
    console.error('Error approving organization:', error);
    throw error;
  }
};

export const activateOrganization = async (id) => {
  try {
    const response = await axios.post(`${Routes.organization}${id}/activate/`);
    return response;
  } catch (error) {
    console.error('Error activating organization:', error);
    throw error;
  }
};

export const suspendOrganization = async (id) => {
  try {
    const response = await axios.post(`${Routes.organization}${id}/suspend/`);
    return response;
  } catch (error) {
    console.error('Error suspending organization:', error);
    throw error;
  }
};

export const rejectOrganization = async (payload) => {
  try {
    const response = await axios.post(`${Routes.organization}${payload.id}/reject/`, payload.body);
    return response;
  } catch (error) {
    console.error('Error rejecting organization:', error);
    throw error;
  }
};

export const updateOrganizationDetail = async (payload) => {
  console.log(payload, 'Payload');

  try {
    const response = await axios.put(`${Routes.organization}${payload.id}/`, payload.data);
    return response;
  } catch (error) {
    console.error('Error fetching organization:', error);
    throw error;
  }
};

// export const getOrganizationByQuery = (obj) => {
//   return axios.get(`/organizations/?type=${obj.type}&state=${obj.state}`, {
//     params: {
//       page: 1,
//       limit: 1000,
//     },
//   });
// };
// eslint-disable-next-line camelcase, no-unused-vars
export const getOrganizationByQuery = ({ type, state, geo_zone, areas_of_focus, search }) => {
  const params = {
    page: 1,
    limit: 1000,
    ...(search !== '' && { search }),
    ...(type !== 'Select One' && type !== 'All' && { type }),
    ...(state !== 'Select One' && state !== 'All' && { state }),
    // eslint-disable-next-line camelcase
    ...(geo_zone !== 'Select One' && geo_zone !== 'All' && { geo_zone }),
    // eslint-disable-next-line camelcase
    ...(areas_of_focus.id !== 'Select One' &&
      // eslint-disable-next-line camelcase
      areas_of_focus.id !== 'All' && { areas_of_focus: areas_of_focus?.id }),
  };

  return axios.get('/organizations/', { params });
};

export const searchOrganization = ({ search }) => {
  return axios.get(`/organizations/?search=${search}`);
};

export const getSingleOrganizations = (id) => axios.get(`${Routes.organization}${id}`);

// export const getProgramArea = () =>
//   axios.get(Routes.program_areas, {
//     params: {
//       page: 1,
//       size: 1000,
//     },
//   });

export const getProgramArea = async () => {
  try {
    const response = await axios.get(Routes.program_areas, {
      params: {
        page: 1,
        size: 1000,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching program areas:', error);
    throw error;
  }
};

export const addOrganization = (payload) => {
  const data = payload;

  if (payload.status === 'active') {
    data.status = true;
  } else data.status = false;
  return axios.post(Routes.organization, data);
};

export const uploadOrganizationsSpreadsheet = (file) => {
  const formData = new FormData();
  formData.append('file', file);

  return axios.post(Routes.organizationSpreadsheetUpload, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getOrganizationImportBatch = (batchId) =>
  axios.get(Routes.organizationImportBatch(batchId));

export const getOrganizationImportBatches = () => axios.get(Routes.organizationImportBatches);

export const saveToDraft = (payload, config = {}) => {
  const data = payload;

  if (data instanceof FormData) {
    if (!data.has('status')) {
      data.append('status', false);
    }
  } else if (payload.status === 'active') {
    data.status = true;
  } else {
    data.status = false;
  }

  return axios.post(Routes.saveToDraft, data, config);
};

export const updateOrganization = (id, payload) => axios.put(Routes.organization + id, payload);

export const patchOrganization = (id, payload) => axios.patch(Routes.organization + id, payload);

export const deleteOrganizationDocuments = (id) =>
  axios.delete(`${Routes.organization + id}/delete_documents/`);

export const deleteOrganization = (id) => axios.delete(Routes.organization + id);

export const news = () => axios.get(Routes.news);
